import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6d08fb88&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=6d08fb88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d08fb88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d08fb88')) {
      api.createRecord('6d08fb88', component.options)
    } else {
      api.reload('6d08fb88', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6d08fb88&scoped=true&", function () {
      api.rerender('6d08fb88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2V0jqQNr6L1JH/JS/comp/SearchFilterTokens.vue"
export default component.exports